import React from "react";

const Error = () => {
  return (
    <div className="h-100 w-100 text-center my-4 ">
      <img
        style={{ height: 250, width: 250 }}
        className="rounded"
        src="/images/logoooo.jfif"
      />
      <div className="my-4 fs-4"> هذه الصفحة غير متوفرة الآن </div>
    </div>
  );
};

export default Error;
